import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { teamMembers, seniormanagement } from "../Data/teamData";
import "./Teamdetail.css";

const TeamDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();


  const boardMember = teamMembers.find((m) => m.id === id);


  const seniorMember = seniormanagement.find((m) => m.id === id);


  const member = boardMember || seniorMember;

  const backRoute = boardMember
    ? "/Corporate/BM"
    : seniorMember
    ? "/Corporate/SM"
    : "/";

  if (!member) return <h2>Member Not Found</h2>;

  return (
    <div className="team-detail">
      <img src={member.img} alt={member.name} />

      <div className="detail-text">
        <h1>{member.name}</h1>
        <h3>{member.role}</h3>
        <p>{member.intro}</p>

        <button
          className="back-btn"
          onClick={() => navigate(backRoute)}
        >
          Back To Team
        </button>
      </div>
    </div>
  );
};

export default TeamDetail;
